import { render, staticRenderFns } from "./DeleteCategoryModal.vue?vue&type=template&id=00c0caa8&scoped=true&"
import script from "./DeleteCategoryModal.vue?vue&type=script&lang=js&"
export * from "./DeleteCategoryModal.vue?vue&type=script&lang=js&"
import style0 from "./DeleteCategoryModal.vue?vue&type=style&index=0&id=00c0caa8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c0caa8",
  null
  
)

export default component.exports